import { parseCookies, setCookie } from 'nookies';

import { COOKIE_EXPIRATION_TIME, TOKEN_COOKIE } from '../utils/constants';

export function createTokenCookies(token: string, refreshToken: string) {
  const isProduction = process.env.NODE_ENV === 'production';
  
  // Sempre salva no localStorage primeiro como backup
  try {
    localStorage.setItem(TOKEN_COOKIE, token);
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
  
  try {
    setCookie(null, TOKEN_COOKIE, token, {
      maxAge: COOKIE_EXPIRATION_TIME,
      path: '/',
      secure: isProduction,
      sameSite: isProduction ? 'none' : 'lax',
    });
  } catch (error) {
    console.warn('Erro ao salvar cookie:', error);
  }

  // setCookie(null, REFRESH_TOKEN_COOKIE, refreshToken, {
  //   maxAge: COOKIE_EXPIRATION_TIME,
  //   path: '/'
  // })
}

export function setDataOnCookie(key:string, value:any){
  const isProduction = process.env.NODE_ENV === 'production';
  
  setCookie(null, key, value,{
     maxAge: COOKIE_EXPIRATION_TIME,
    path: '/',
    secure: isProduction,
    sameSite: isProduction ? 'none' : 'lax',
  })
}

export function getDataOnCookie(key:string){
  const cookies = parseCookies();
  return cookies[key];
}

export function removeTokenCookies() {
  document.cookie = TOKEN_COOKIE + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  localStorage.removeItem(TOKEN_COOKIE);
  // document.cookie = REFRESH_TOKEN_COOKIE + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
export function getToken() {
  const cookies = parseCookies();
  const tokenFromCookie = cookies[TOKEN_COOKIE];
  const tokenFromStorage = localStorage.getItem(TOKEN_COOKIE);
  
  // Prioriza localStorage já que salvamos lá primeiro
  if (tokenFromStorage) {
    return tokenFromStorage;
  }
  
  // Fallback para cookie
  if (tokenFromCookie) {
    return tokenFromCookie;
  }
  
  return undefined;
}

export function getRefreshToken() {
  const cookies = parseCookies();
  return cookies[TOKEN_COOKIE];
  // return cookies[REFRESH_TOKEN_COOKIE]
}